import React, { Component, useState } from 'react';

import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import { KuposButton } from '../../../common';
import PropTypes from 'prop-types';
import RatingItem from './components/RatingItem';
import RatingMouseOver from './components/RatingMouseOver';
import RatingsMouseOver from './components/RatingMouseOver';
import SvgAmenities from '../../../common/SvgAmenities';
import SvgServiceList from '../../../common/SvgServiceList';
import TerminalMouseOver from './components/TerminalMouseOver';
import DurationMouseOver from './components/DurationMouseOver';

function ServiceItem(props) {
  let amenitiesMoreDivHeight = [];
  let amenityItemEl = [];
  let terminalEl = [];
  let seatTypeEl = [];

  let boardingStageId,
    dropOffStageId,
    originTerminals,
    boardingStages,
    dropOffStages,
    terminalInfos,
    showTerminalMouseOver = false;

  // console.log('All Props in serviceItem are------->', props);

  if (props.serviceItem.boarding_stages) {
    boardingStageId =
      props.serviceItem.boarding_stages && props.serviceItem.boarding_stages.split('|')[0];
    boardingStages = props.serviceItem.boarding_stages && props.serviceItem.boarding_stages;
    dropOffStageId =
      props.serviceItem.dropoff_stages && props.serviceItem.dropoff_stages.split('|')[0];
    dropOffStages = props.serviceItem.dropoff_stages && props.serviceItem.dropoff_stages;
  }

  // if (props.serviceItem.terminal_info) {
  //   originTerminals = props.serviceItem.terminal_info && props.serviceItem.terminal_info.split('@');
  //   originTerminals.pop();

  //   terminalInfos = props.serviceItem.terminal_info && props.serviceItem.terminal_info.split('@');
  //   terminalInfos.pop();
  // }

  if (props.serviceItem.terminal_info) {
    //  originTerminals =
    //    props.serviceItem.terminal_info && props.serviceItem.terminal_info.split('@');
    //  originTerminals.pop();

    showTerminalMouseOver = true;

    terminalInfos = props.serviceItem.terminal_info && props.serviceItem.terminal_info.split('@');
    terminalInfos.pop();

    // console.log('testing terminal infos----', terminalInfos);
  }

  const onBookButtonPress = () => {
    props.onBookButtonPress();
    setTimeout(() => {
      var item = document.querySelector('#pb-service-list-service-item-' + props.serviceItem.id);
      var itemCard = document.querySelector(
        '#pb-service-list-service-item-' + props.serviceItem.id + ' > .kupos-card',
      );
      var nav = document.querySelector('.nav-container');
      window.scrollTo(0, item.offsetTop - nav.clientHeight + 60 + itemCard.clientHeight);
    }, 500);
  };

  const getSeatName = rawSeat => {
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'Salon':
        return 'Salón';
        break;
      case 'SALON CAMA P':
        return '';
      case 'SALON CAMA IND':
        return '';
      default:
        return CommonService.capitalize(rawSeat);
        break;
    }
  };

  const getBoardingStage = stageId => {
    return props.stagesData && props.stagesData[stageId];
  };

  const getTerminals = boardingStages => {
    let terminals = '';

    boardingStages &&
      boardingStages.split(',').map(val => {
        terminals +=
          val.split('|')[2] && val.split('|')[2] == 2
            ? (props.stagesData && props.stagesData[val.split('|')[0]]
                ? props.stagesData[val.split('|')[0]]
                : '') +
              ' - ' +
              val.split('|')[1] +
              '\n(' +
              t('TRANSLATIONS.NEXT_NEXT_DAY') +
              ')\n'
            : val.split('|')[2] && val.split('|')[2] == 1
            ? (props.stagesData && props.stagesData[val.split('|')[0]]
                ? props.stagesData[val.split('|')[0]]
                : '') +
              ' - ' +
              val.split('|')[1] +
              '\n(' +
              t('TRANSLATIONS.NEXT_DAY') +
              ')\n'
            : (props.stagesData && props.stagesData[val.split('|')[0]]
                ? props.stagesData[val.split('|')[0]]
                : ' ') +
              ' - ' +
              val.split('|')[1] +
              '\n';

        // props.stagesData[val.split('|')[0]] + ' - ' + val.split('|')[1] + '\n';
      });

    return terminals;
  };

  const getTerminalInfo = () => {
    let terminals = '';

    // console.log('testing terminalInfos----', terminalInfos);

    terminalInfos &&
      terminalInfos.map(val => {
        terminals +=
          val.split('|')[2] && val.split('|')[2] == 2
            ? val.split('|')[0] +
              ' - ' +
              val.split('|')[1] +
              '\n(' +
              t('TRANSLATIONS.NEXT_NEXT_DAY') +
              ')\n'
            : val.split('|')[2] && val.split('|')[2] == 1
            ? val.split('|')[0] +
              ' - ' +
              val.split('|')[1] +
              '\n(' +
              t('TRANSLATIONS.NEXT_DAY') +
              ')\n'
            : val.split('|')[0] !== ''
            ? val.split('|')[0] + ' - ' + val.split('|')[1] + '\n'
            : '';

        // props.stagesData[val.split('|')[0]] + ' - ' + val.split('|')[1] + '\n';
      });

    return terminals;
  };

  const getAmenityName = rawAnemity => {
    // console.log('Raw amenity ---------', rawAnemity);
    switch (rawAnemity) {
      case 'mobile ticket':
        return 'RESULTS_PAGE.MOBILE_TICKET';
        break;
      case 'charging plug':
        return 'RESULTS_PAGE.CHARGING_PLUG';
        break;
      case 'wifi':
        return 'RESULTS_PAGE.WIFI';
        break;
      case 'movie':
        return 'RESULTS_PAGE.ENTERTAINMENT';
        break;
      case 'baggage':
        return 'RESULTS_PAGE.BAGGAGE';
        break;
      case 'Restrooms':
        return 'RESULTS_PAGE.RESTROOMS';
        break;
      case 'air condtion':
        return 'RESULTS_PAGE.AIR_CONDITIONER';
        break;
      case 'snacks new':
        return 'RESULTS_PAGE.SNACKS';
        break;
      case 'coffee':
        return 'RESULTS_PAGE.COFFEE';
        break;
      default:
        return rawAnemity;
        break;
    }
  };

  let { t } = props;
  const { serviceItem, metaData } = props;
  // if (metaData) console.log('helllo', metaData.amenities[10]);

  // let offer_text = 'The description that needs to be [[shown[[ in API';

  const isPetSeat = (Object.keys(props.serviceItem.pet_seat_info) || []).length > 0;
  // console.log('try try getOriginTerminals()-----', getOriginTerminals());
  // Mascota a bordo
  return (
    <div
      className={
        'pb-service-list-service-item service-card mb-30' +
        (serviceItem.available_seats <= 0 ? 'sold-out' : '')
      }
      id={'pb-service-list-service-item-' + serviceItem.id}
    >
      {props.children}

      <div className="kupos-card">
        <div className={serviceItem.available_seats <= 0 ? 'sold-out' : ''}>
          {props.serviceItem.is_direct_trip && (
            <div className="direct-ui-container">
              <img src="/images/Icon-Desktop-Background.png" alt="" className="bg" />
              <img src="/images/Icon-Desktop.png" alt="" className="arrow" />
              <span className="text bold-text">DIRECTO</span>
            </div>
          )}
          {serviceItem.offer_text && (
            <div className="offer-text font11">
              {/* <span className="offer-percent">%</span> */}
              <div className="offer-tag-image-container">
                <img src="/svgs/PromotionCode.svg" alt="offer-tag" />
              </div>
              <span className="offer-text-span">
                {serviceItem.offer_text.split('[[')[0].toUpperCase()}{' '}
                {serviceItem.offer_text.split('[[')[1] ? (
                  <span className="bold-text" style={{ color: '#003ba7' }}>
                    {' '}
                    {`"${serviceItem.offer_text.split('[[')[1].toUpperCase()}"`}
                  </span>
                ) : null}{' '}
                {serviceItem.offer_text &&
                  serviceItem.offer_text.split('[[')[2] &&
                  serviceItem.offer_text.split('[[')[2].toUpperCase()}
              </span>
            </div>
          )}
          <div className="operator-info-row flex-row font10">
            <div className="op-logo">
              <img src={serviceItem.operator_details[0]} />
            </div>
            <div className="op-name light-text font11 uppercase-text">
              {serviceItem.operator_details[2]}
            </div>
          </div>
          <div className="service-info-row flex-row">
            <div className="flex-row time-stars-row padding-B30" style={{ paddingBottom: 27 }}>
              <div className="amenities-star">
                {/* <div className="stars bold-text font13">
                {serviceItem.operator_details[1].toFixed(1)}
                <img src="/images/icons/Icon-star-full-orange.png" />
                {<RatingMouseOver service={serviceItem} t={props.t} />}
              </div> */}
                <div className="amenities-info-row flex-row">
                  <div className="amenities-row flex-row">
                    {isPetSeat && (
                      <div className="aminity-img">
                        <span>
                          {/* <img src="/images/seats/PetsOnBoardIIcon.svg" /> */}
                          <img
                            src="/images/seats/PetsOnBoardIIcon.svg"
                            alt=""
                            style={{ width: '34px' }}
                          />
                        </span>
                        <div
                          id={'amenity' + serviceItem.id}
                          className="amenities-item-mouse-over mouseover-popups nowrap font9"
                          style={{ textTransform: 'inherit' }}
                        >
                          Mascota a bordo
                        </div>
                      </div>
                    )}
                    {/* {metaData && serviceItem.operator_details[4]
                    ? serviceItem.operator_details[4].map((val, key) => {
                      return key < (isPetSeat ? 1 : 2) &&
                        metaData.amenities[val].split('.')[0].toUpperCase() != 'WATER' ? (
                        <div className="aminity-img" key={key}>
                          <SvgAmenities
                            name={metaData.amenities[val].split('.')[0].toUpperCase()}
                          />
                          <div
                            id={'amenity' + serviceItem.id}
                            className="amenities-item-mouse-over mouseover-popups nowrap font9"
                          >
                            {t(
                              getAmenityName(
                                metaData.amenities[val]
                                  .split('.')[0]
                                  .split('_')
                                  .join(' '),
                              ),
                            )}
                          </div>
                        </div>
                      ) : null;
                    })
                    : null} */}
                    {/* {metaData &&
                    serviceItem.operator_details[4] &&
                    serviceItem.operator_details[4].length > 2 ? (
                    <div className="amenities-more-icon">
                      <img src={'/images/icons/amenities/icon_plus.svg'} />
                      <div className="amenities-more-div mouseover-popups nowrap font9">
                        {metaData && serviceItem.operator_details[4]
                          ? serviceItem.operator_details[4].map((val, key) => {
                            return key >= 2 &&
                              metaData.amenities[val].split('.')[0].toUpperCase() != 'WATER' ? (
                              <div className="amenities-more-row" key={key}>
                                <SvgAmenities
                                  name={metaData.amenities[val].split('.')[0].toUpperCase()}
                                  color="white"
                                />
                                <span>
                                  {t(
                                    getAmenityName(
                                      metaData.amenities[val]
                                        .split('.')[0]
                                        .split('_')
                                        .join(' '),
                                    ),
                                  )}
                                </span>
                              </div>
                            ) : null;
                          })
                          : null}
                        <span className="primary-triangle"> </span>
                      </div>
                    </div>
                  ) : null} */}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-row time-stars-row">
              <div className="datetime-info">
                <div className="time-row flex-row">
                  <div className="time-info bold-text">
                    <span className="time font13"> {serviceItem.dep_time} </span>
                    <span className="ampm font8">
                      {' '}
                      {DateService.ampmOnly(serviceItem.dep_time)}{' '}
                    </span>
                    {
                      <TerminalMouseOver
                        terminalEl={terminalEl}
                        service={serviceItem}
                        // terminals={originTerminals}
                        // label={getOriginTerminals()}
                        // label={getBoardingStage(boardingStageId)}
                        label={getTerminals(boardingStages)}
                        // label={boardingStage}
                        // label={t('RESULTS_PAGE.BOARDING_POINT3')}
                        direction={1}
                      />
                    }
                  </div>
                  <div className="duration font9 light-text duration-hover">
                    <div>
                      <span> {serviceItem.duration} </span>
                      <span className="hours"> {t('RESULTS_PAGE.HOURS')} </span>
                    </div>
                    {/* <SvgServiceList name="duration-arrow" /> */}
                    <div className="position-relative">
                      <img src="/images/trip-duration-scroll-down-arrow-one-direction.svg" alt="" />
                    </div>

                    {showTerminalMouseOver && (
                      <DurationMouseOver
                        terminalEl={terminalEl}
                        service={serviceItem}
                        // terminals={originTerminals}
                        // label={getOriginTerminals()}
                        label={getTerminalInfo()}
                        // label={'SOME MESSAGE'}
                      />
                    )}
                  </div>
                  <div className="time-info bold-text">
                    <span className="time font13"> {serviceItem.arr_time.slice(0, 5)} </span>
                    <span className="ampm font8">
                      {' '}
                      {DateService.ampmOnly(serviceItem.arr_time)}{' '}
                    </span>
                    {
                      <TerminalMouseOver
                        terminalEl={terminalEl}
                        service={serviceItem}
                        // label={t('RESULTS_PAGE.DROP_OFF_POINT3')}
                        // label={getBoardingStage(dropOffStageId)}
                        label={getTerminals(dropOffStages)}
                        direction={2}
                      />
                    }
                  </div>
                </div>
                <div className="date-row flex-row font11 light-text">
                  <span className="">
                    {DateService.getServiceItemDate(serviceItem.travel_date)}
                  </span>
                  <span className="">
                    {DateService.getServiceItemDate(serviceItem.arrival_date)}
                  </span>
                </div>
              </div>
            </div>
            <div
              className={
                'seat-info font11  bold-text ' +
                (serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length <= 1
                  ? 'single-type '
                  : '') +
                (serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length == 3
                  ? 'three-type '
                  : '')
              }
            >
              {serviceItem.fare_str.split(',').map((val, key) => {
                return (
                  <span
                    key={key}
                    className={
                      'seattype-name' + serviceItem.available_seats <= 0 ? ' sold-out' : ' '
                    }
                  >
                    {getSeatName(val.split(':')[0])}
                  </span>
                );
              })}
            </div>
            <div
              className={
                'seat-price-info bold-text font13 ' +
                (serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length <= 1
                  ? 'single-type '
                  : '') +
                (serviceItem.fare_str.split(',') && serviceItem.fare_str.split(',').length == 3
                  ? 'three-type '
                  : '')
              }
            >
              {console.log('serviceItem.fare_str', serviceItem.fare_str)}
              {serviceItem.fare_str.split(',').map((val, key) => {
                return (
                  <span key={key}> {CommonService.currency(val.split(':')[1]).split(',')[0]} </span>
                );
              })}
            </div>
            <div
              className={
                'button-col font12 ' +
                (serviceItem.fare_str.split(',') &&
                serviceItem.fare_str.split(',').length <= 1 &&
                !(serviceItem.available_seats < 10 && serviceItem.available_seats > 0)
                  ? 'single-type '
                  : 'single-type') +
                (serviceItem.available_seats <= 0 ? 'sold-out' : '')
              }
            >
              <KuposButton
                onClick={serviceItem.available_seats > 0 ? onBookButtonPress : null}
                className={serviceItem.available_seats <= 0 ? 'sold-out' : ''}
              >
                {serviceItem.available_seats > 0 ? (
                  t('RESULTS_PAGE.BUY')
                ) : (
                  <span
                    // className="sold-out-span"
                    style={{ cursor: serviceItem.available_seats > 0 ? 'pointer' : 'not-allowed' }}
                  >
                    {' '}
                    {t('RESULTS_PAGE.SOLD_OUT')}{' '}
                  </span>
                )}
                {serviceItem.available_seats <= 0 ? <img src="/svgs/sold-out.svg" /> : null}
              </KuposButton>
              {serviceItem.available_seats < 10 && serviceItem.available_seats > 0 ? (
                <div className="fast-filling bold-text font9 secondary-text">
                  ¡ Últimos Asientos!
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceItem;



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/ServiceItem/ServiceItem.js